import React, { Component } from 'react';
import SubcategoriesMultisitesContent from './SubcategoriesMultisitesContent';

class MegamenuMultisitesContent extends Component {
  setAllSubcategoriesMulti = () => {}

  render() {
    // const { setOverCategoryItem, overCategoryItem, selectData } = this.props;
    const { setOverCategoryItem, selectData } = this.props;

    const displayList = (selectData && selectData.l2subcategories && selectData.l2subcategories.slice(0, 8)) || [];
    const selectDataLength = displayList.length;

    return (
      <section
        onMouseEnter={() => setOverCategoryItem(true)}
        onMouseLeave={() => setOverCategoryItem(false)}
      >
        {
          selectData && selectData.name && (
            <SubcategoriesMultisitesContent
              displayList={displayList}
              selectDataLength={selectDataLength}
              setAllSubcategoriesMulti={this.setAllSubcategoriesMulti}
              selectData={selectData}
            />
          )
        }
      </section>
    );
  }
}

export default MegamenuMultisitesContent;
